import { OutputBlockData } from '@editorjs/editorjs';

export const parseImage = (img: HTMLImageElement): OutputBlockData[] => [
  {
    type: 'image',
    data: {
      file: { url: img.src },
      caption: img.alt || '',
    },
  },
];
